export default __webpack_public_path__ + "static/media/Leila_Zerrougui.cf6a6904.png";